import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, input, TemplateRef } from '@angular/core';

import { FADE_IN_CONTENT_BY_OPACITY } from '@app/core/constants/animations.constant';

@Component({
    selector: 'dp-tooltip',
    imports: [NgTemplateOutlet],
    templateUrl: './tooltip.component.html',
    styleUrl: './tooltip.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [FADE_IN_CONTENT_BY_OPACITY]
})
export class DpTooltipComponent {
  @HostBinding('@fadeInContentByOpacity') animate = true;
  text = input<string>();
  contentTemplate = input<TemplateRef<never>>();
}
